import { createAction } from 'redux-actions';

export default {
    UpdateColumnCfg: createAction('UPDATE_COLUMN_CFG'),
};
